import { destroy, get, internalPost, post, patch, put } from '.';
import qs from 'qs';

export const createFolder = (payload) => post(`folders`, payload);

export const getUniqueIcr = (organizationId, payload) =>
  post(`folders/getUniqueIcr?organizationId=${organizationId}`, payload);

export const updateFolder = (id, payload) => patch(`folders/${id}`, payload);

export const deleteFolderTraveler = (folderId, travelerId) =>
  destroy(`folders/${folderId}/travelers/${travelerId}`);

export const getFolderByIcr = (icr, orgId) =>
  get(`folders/${icr}?organizationId=${orgId}`);

// The ids can come from a shared search link: encoded, they stay one segment.
export const getFolderById = ({ id }) =>
  get(`folders/${encodeURIComponent(id)}`);

export const addTravelerToFolder = ({ id, travelers }) =>
  post(`folders/${encodeURIComponent(id)}/travelers`, travelers);

export const updateTravelerToFolder = (id, payload) =>
  put(`folders/${encodeURIComponent(id)}/travelers`, payload);

export const getFolders = ({ filters, search, from, to }) => {
  return get(`folders?${qs.stringify({ search, from, to, ...filters })}`);
};

export const cancelFolderBookings = (id, payload) =>
  post(`folders/${encodeURIComponent(id)}/bookings/cancel`, payload);

// KD-3842: archiving lives under /api/internal (users only, no API keys).
export const archiveFolder = (id) =>
  internalPost(`folders/${encodeURIComponent(id)}/archive`);

export const unarchiveFolder = (id) =>
  internalPost(`folders/${encodeURIComponent(id)}/unarchive`);
